import { Button, mergeClasses, Tooltip } from '@fluentui/react-components'
import { Document20Filled, Document20Regular } from '@fluentui/react-icons'
import { useTranslation } from 'react-i18next'
import { WORKING_DOCUMENT_ID } from '../../constants/files'
import { useSelectedContext } from '../../hooks'
import { useDocumentName } from '../../hooks/useDocumentName'
import { useContextSourceBadgeStyles } from './contextSourceBadge.styles'

/**
 * Toggle for excluding the working Word document from AI context.
 * Active when the document is not excluded from context.
 */
export const DocumentContextBadge = () => {
  const classes = useContextSourceBadgeStyles()
  const { t } = useTranslation()

  const { getFileSelection, updateFileSelection } = useSelectedContext()
  const workingDocFile = getFileSelection(WORKING_DOCUMENT_ID)
  const isActive = workingDocFile !== undefined
  const { data: workingDocumentTitle } = useDocumentName(!isActive)
  const label = isActive ? t('contextBar.documentActive') : t('contextBar.documentInactive')

  const handleClick = () => {
    if (isActive) {
      updateFileSelection({ ...workingDocFile, sections: null })
      return
    }

    // Match FileCard: store the real Word title so ContextCard can show filename
    // as primary and "This document" only as the working-doc subtitle.
    updateFileSelection({
      id: WORKING_DOCUMENT_ID,
      fileName: workingDocumentTitle ?? t('files.untitledDocument'),
      extension: 'docx',
      sections: [],
    })
  }

  return (
    <Tooltip content={label} relationship="label" appearance="inverted">
      <Button
        className={mergeClasses(classes.badge, isActive ? classes.active : classes.inactive)}
        appearance="subtle"
        size="small"
        shape="circular"
        icon={
          isActive ? (
            <Document20Filled aria-hidden={true} />
          ) : (
            <Document20Regular aria-hidden={true} />
          )
        }
        aria-label={label}
        aria-pressed={isActive}
        onClick={handleClick}
      />
    </Tooltip>
  )
}
